export const LOCAL_AUTH_TOKEN_KEY = 'vb-auth-token';
